import React from "react";
import { IFeaturedDestinationsProps } from "./FeaturedDestinationsProps";
import {
  CityContainer,
  Container,
  Description,
  DestinationContainer,
  FindYourDestination,
  StyledSubTitle,
} from "./FeaturedDestinationsHelpers";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Title } from "./FeaturedDestinationsHelpers";
import { IDestination } from "../../../@types/IDestination";
import Destination from "./Destination/Destination";

const FeaturedDestinations: React.FC<IFeaturedDestinationsProps> = (props) => {
  return (
    <Container>
      <DestinationContainer>
        <Row className="flexText">
          <Col className={`col6`}>
            <StyledSubTitle>{props.field_title}</StyledSubTitle>
            <Title>{props.field_subtitle}</Title>
          </Col>
          <Col className={`col6`}>
            <Description {...props}></Description>
            <FindYourDestination />
          </Col>
        </Row>
        <Row className="flexImage">
          <Col>
            <CityContainer>
              {props.relationships.field_destinations.map(
                (destination: IDestination, index: number) => {
                  return <Destination key={index} {...destination} />;
                }
              )}
            </CityContainer>
          </Col>
        </Row>
      </DestinationContainer>
    </Container>
  );
};

export default FeaturedDestinations;
